import { getImagesStaticUrl } from '../../../helpers';
import useScreenMode from '../../../hooks/useScreenMode';
import { DESKTOP } from '../../constants';
import { reactivateTodayPerks as perks } from './constants';
import PinkCircle from '../pink-circle.png';
import PinkCircle2x from '../pink-circle@2x.png';
import './styles.scss';

const PerksBanner = () => {
  const screenMode = useScreenMode();
  const imageToFetch = screenMode !== DESKTOP ? PinkCircle : PinkCircle2x;
  const imageToShow =
    screenMode !== DESKTOP ? 'open-box-girls-smiling.png' : 'open-box-girls-smiling@2x.png';
  return (
    <section className="today-perks" data-testid="today-perks">
      <div
        className="today-perks__image-container"
        style={{
          background: `url(${getImagesStaticUrl(imageToShow)}) center center / contain no-repeat`,
        }}
        data-testid="today-perks-image-container"
      >
        <img src={imageToFetch} alt="Color circle" />
      </div>
      <div className="today-perks__list-container">
        <h1 className="today-perks__list-title">Membership Perks</h1>
        <ul className="today-perks__list">
          {perks.map(({ title, description, icon }) => (
            <li key={title} className="today-perks__list-item">
              <div>
                <i className={`fal ${icon} fa-fw`} />
              </div>
              <div>
                <h4>{title}</h4>
                <p>{description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default PerksBanner;
